import abbotLogo from '../../assets/images/logo-abbott.svg';
import deLogo from '../../assets/images/logo-de.png';

const footer = {
  title: 'Footer',
  rightLogo: {
    image: deLogo,
    altText: 'Discovery Education Logo'
  },
  leftLogo: {
    image: abbotLogo,
    altText: 'Abbott Logo'
  }
};

export default footer;



// WEBPACK FOOTER //
// ./src/data/footer/index.js